import { useState } from "react";

import { QueryKeys, useEntity } from "@/api/core";
import { type PredictionStatus, predictionStatusSchema } from "@/schemas";

interface UsePredictionOpts {
  isEnabled?: boolean;
}

function usePrediction(statusId: string | null, opts: UsePredictionOpts = {}) {
  const { isEnabled = true } = opts;
  const [poolingInterval, setPoolingInterval] = useState(3);

  const queryInfo = useEntity<PredictionStatus>({
    enabled: !!statusId && isEnabled,
    endpoint: `/api/v1/predictions/statuses/${statusId}`,
    id: statusId,
    queryKey: QueryKeys.predictions.prediction(statusId!),
    schema: predictionStatusSchema,
    getResponseHeaders: (headers) => {
      if (headers["x-predictions-refresh-interval"]) {
        setPoolingInterval(Number(headers["x-predictions-refresh-interval"]));
      } else {
        setPoolingInterval(-1);
      }
    },
    refetchInterval: () => {
      if (poolingInterval === -1) return false;
      return poolingInterval * 1000;
    },
  });

  return {
    ...queryInfo,
    status: queryInfo.entity,
    poolingInterval,
  };
}

export { usePrediction };
